// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.min.js";

// Hero image horizontal positioning
$('.fc-hero').each(function () {
  var focalX = $(this).attr('image-x');
  var focalY = $(this).attr('image-y');
  $(this).css('background-position', focalX + '% ' + focalY + '%');
  $(this).css('visibility', 'visible').hide().fadeIn('slow');
});

// Hero content horizontal and vertical positioning
$(window).resize(function () {

  var heroHeight = $('.fc-hero').first().height();
  if (heroHeight > 747) {
    $('.menu, .contact').css('height', heroHeight + 'px');
  }

  $('.hero-content, .hero-content-home').each(function () {
    var leftPercentage;
    var topPercentage;
    if ($(window).width() < 767) {
      leftPercentage = $(this).attr('phone-x');
      topPercentage = $(this).attr('phone-y');
      $(this).addClass($(this).attr('phone-style'));
    } else if ($(window).width() < 989) {
      leftPercentage = $(this).attr('tablet-x');
      topPercentage = $(this).attr('tablet-y');
      $(this).addClass($(this).attr('tablet-style'));
    } else if ($(window).width() < 1200) {
      leftPercentage = $(this).attr('desktop-x');
      topPercentage = $(this).attr('desktop-y');
      $(this).addClass($(this).attr('desktop-style'));
    } else {
      leftPercentage = $(this).attr('large-x');
      topPercentage = $(this).attr('large-y');
      $(this).addClass($(this).attr('large-style'));
    }
    var contentHeight = $(this).height();
    var contentWidth = $(this).width();
    var heroHeight = $(this).parent().height();
    var heroWidth = $(this).parent().width();
    var left = (heroWidth * (leftPercentage / 100.0)) - (contentWidth / 2);
    var top = (heroHeight * (topPercentage / 100.0)) - (contentHeight / 2);

    (left > heroWidth - contentWidth) && (left = heroWidth - contentWidth);
    (left < 0) && (left = 0);
    (top > heroHeight - contentHeight) && (top = heroHeight - contentHeight);
    (top < 0) && (top = 0);
    $(this).css({
      'top': (top - 10) + 'px',
      'left': left + 'px'
    });
  });
});
$(window).resize();
$('.hero-slider').each(function () {
  $(this).slick({
    infinite: true,
    fade: true,
    cssEase: 'linear',
    speed: 2000,
    slidesToShow: 1,
    centerMode: true,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 4000,
    pauseOnHover: false,
  });
});
